/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_Step2Inputs */

const en_gc_resources_guide_formulas_step2 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select A5 and enter =SUM(A2:A4). Press Enter. The result should be 250.`)
};

const zh_gc_resources_guide_formulas_step2 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 A5，输入 =SUM(A2:A4)，按回车，结果应为 250。`)
};

/**
* | output |
* | --- |
* | "Select A5 and enter =SUM(A2:A4). Press Enter. The result should be 250." |
*
* @param {Gc_Resources_Guide_Formulas_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_step2 = /** @type {((inputs?: Gc_Resources_Guide_Formulas_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_step2(inputs)
	return zh_gc_resources_guide_formulas_step2(inputs)
});
export { gc_resources_guide_formulas_step2 as "gc.resources.guide.formulas.step2" }